module.exports = __webpack_public_path__ + "img/widrp_tokenumkmwax.ced0186.png";